var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconHelpInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h28v28H0z"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#C3D2DF"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 12.5,
    fill: "#FFF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#C3D2DF",
    strokeWidth: 0.948
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.868 18.573c-.544 0-1 .409-1 .895v.02c0 .486.456.895 1 .895.543 0 .999-.409.999-.895v-.04c0-.486-.456-.875-1-.875zM13.824 8C11.716 8 10 9.537 10 11.424c0 .312.282.564.63.564.348 0 .63-.252.63-.564 0-1.264 1.152-2.296 2.564-2.296.978 0 1.803.35 2.216.934.652.915.218 1.83-.39 2.393-.175.156-.392.331-.63.506-.805.603-1.826 1.343-1.826 2.452 0 .31.282.564.63.564.348 0 .63-.253.63-.564 0-.565.695-1.09 1.347-1.576.261-.195.522-.39.739-.584 1.217-1.09 1.434-2.568.565-3.794C16.475 8.545 15.236 8 13.825 8z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHelpInactive);
export default __webpack_public_path__ + "static/media/icon_help_inactive.52bcd6b2a9792869573a92312f232597.svg";
export { ForwardRef as ReactComponent };